import styled from "styled-components";
export const UsersWrapper = styled.div`
  background-color: #fff;
  width: 100%;
`;
